<template>
  <div>
    <!-- User -->
    <ul class="navbar-nav align-items-center d-none d-md-flex">
        <b-nav-item-dropdown right>
            <template slot="button-content">
                <div class="media align-items-center">
                    <span class="avatar avatar-sm rounded-circle">
                        <img alt="Image placeholder" src="@/assets/img/theme/user.png">
                    </span>
                    <div class="media-body ml-2 d-none d-lg-block">
                        <span class="d-block text-sm font-weight-bold mb-1">{{ userName }}</span>
                        <span class="d-block text-sm font-weight-light">{{ email }}</span>
                    </div>
                    
                </div>
            </template>
            <b-dropdown-item v-if="userRollId == 2" @click='changePassword'>Change Password</b-dropdown-item>
            <b-dropdown-item v-if="userRollId == 2" @click='manageSites'>My Sites</b-dropdown-item>
            <b-dropdown-item @click='logoutUser'>Signout
              <span>( {{ email }} )</span>
            </b-dropdown-item>
        </b-nav-item-dropdown>
    </ul>
    {{ getData }}
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'userData',
    data: () => ({
        userName  : 'logged user name',
        email : "",
        userImage : '',
        userRollId: localStorage.roleId
    }),
    computed: {
        ...mapGetters('authentication', ['userDetailsGetter',]),
        getData() {
            if(localStorage.userName){
                this.userName = localStorage.userName;
                this.email = localStorage.email;
            }
        }
    },
    methods : {
        logoutUser() {
            localStorage.clear();
            this.$router.push('/adminLogin');
        },
        changePassword () {
            this.$router.push('/change-password');
        },
        manageSites () {
            this.$router.push({ name: 'sitePreferences' });
        }
    },
    // created() {
    //     if(localStorage.userData != ''){
    //         this.userName  = localStorage.userName;
    //     }
    // },
  }
</script>



// WEBPACK FOOTER //
// src/pages/Common/userData.vue